import { FormInstance, RuleObject } from "antd/lib/form"
import { Moment } from "moment"

import { checkMaxDate, checkMinDate } from "./utils.rules"

export const generateDateRangeRules = ({ formInstance, minDateName, maxDateName }: { formInstance: FormInstance; minDateName: string; maxDateName: string }) => ({
    minDate: [
        {
            validator: (_rule: RuleObject, value: Moment) => checkMinDate({ formInstance, value, name: maxDateName }),
        },
    ],
    maxDate: [
        {
            validator: (_rule: RuleObject, value: Moment) => checkMaxDate({ formInstance, value, name: minDateName }),
        },
    ],
})
